export default {
  breadcrumb: {
    settlements: "Radicaciones >",
    settlementId: "Radicación {id} "
  },
  title: "Radicación",
  createdAt: "Fecha de radicación",
  totalAmount: "Monto Total",
  sponsor: "Aseguradora: ",
  loadingDataLabel: "Cargando reclamos",
  emptyDataLabel: "No hay reclamos en esta radicación",
  resultLabel: "{result} Reclamo | {result} Reclamos",
  NoResults: "No se encontraron reclamos",
  attachedDocuments: 'Documentos adjuntos | {count} Documento adjunto | {count} Documentos adjuntos',
  grid: {
    authorizationId: "ID",
    createdAt: "Fecha de creación",
    beneficiary: "Beneficiario",
    memberCode: "Carnet",
    coverage: "Cobertura", 
    branch: "Sucursal",
    amount: "Monto a pagar"
  },
  filters: {
    searchCode: "Buscar por ID de reclamo"
  },
  reasonRejection: "Motivo de rechazo",
  manualAuthorizations: {
    tittle: "Autorizaciones manuales",
    quantity: "Cantidad",
    amount: "Monto"
  }
}
